document.addEventListener('DOMContentLoaded', () => {
  const mainButton = document.getElementById('main_add_to_cart');
  const stickyButton = document.getElementById('sticky_add_to_cart');
  const footer = document.getElementById('footer-bottom-copyright');
  const notifAchat = document.getElementById('notif_achat');

  if (!mainButton || !stickyButton || !footer) {
    console.error('Un ou plusieurs éléments nécessaires sont manquants.');
    return;
  }

  // Calculer la distance entre le haut de l'écran et mainButton
  const mainButtonOffsetTop = mainButton.getBoundingClientRect().top + window.pageYOffset;

  const handleScroll = () => {
    if (window.scrollY >= mainButtonOffsetTop) {
      // Crée un observateur pour surveiller la visibilité du bouton principal
      var mainButtonObserver = new IntersectionObserver(function (entries) {
        // Si intersectionRatio vaut 0 ou moins, la cible
        // est hors de vue et afficher la class
        if (entries[0].intersectionRatio <= 0) {
          stickyButton.classList.add('is-visible');
          notifAchat.classList.add('change-position');
        } else {
          stickyButton.classList.remove('is-visible');
          notifAchat.classList.remove('change-position');
        }
      });

      // Crée un observateur pour surveiller la visibilité du pied de page
      var footerObserver = new IntersectionObserver(function (entries) {
        // Si intersectionRatio vaut 0 ou moins, la cible
        // est hors de vue et afficher la class
        if (entries[0].intersectionRatio <= 0) {
          stickyButton.classList.add('is-visible');
          notifAchat.classList.add('change-position');
        } else {
          stickyButton.classList.remove('is-visible');
          notifAchat.classList.remove('change-position');
        }
      });

      // Observer le bouton principal
      mainButtonObserver.observe(mainButton);

      // Observer le pied de page
      footerObserver.observe(footer);

      // Supprimer l'écouteur de défilement après l'initialisation des observateurs
      window.removeEventListener('scroll', handleScroll);
    }
  };

  // Ajouter un écouteur de défilement
  window.addEventListener('scroll', handleScroll);
});
